<app-menu [login]="login" [nombres]="user != null ? user.names : ''"
    [perfil]="user != null ? user.profile_name : ''"></app-menu>

<div class="container container-info-home">
    <div class="row">
        <div class="col-md-12 text-center mt-4 mb-4">
            <h1>Bienvenido</h1>
        </div>
        <div class="col-md-3" *ngIf="user.profile_id === 1">
          <div class="container-modulo-home text-center" [style]="active1 ? 'cursor: pointer' : ''"  (click)="active1 ? irPagina('region', '1') : ''">
              <h3>Cuentas</h3>
              <img [src]="active1 ? '/assets/img/homepage-people.jpg' : '/assets/img/homepage-people.jpg'" class="img-modulo-home"/>
          </div>
        </div>
        <div class="col-md-3" *ngIf="user.profile_id === 3">
          <div class="container-modulo-home text-center" [style]="active1 ? 'cursor: pointer' : ''"  (click)="active1 ? irPagina('advertiser', '1') : ''">
              <h3>Anunciantes</h3>
              <img [src]="active1 ? '/assets/img/homepage-people.jpg' : '/assets/img/homepage-people.jpg'" class="img-modulo-home"/>
          </div>
      </div>
        <div class="col-md-3" *ngIf="user.profile_id === 2">
            <div class="container-modulo-home text-center" [style]="active1 ? 'cursor: pointer' : ''" (click)="active1 ? irPagina('campaigns-user', '1') : ''">
                <h3>Campañas</h3>
                <img [src]="active1 ? '/assets/img/homepage-businesses-1.jpg' : '/assets/img/homepage-businesses-1.jpg'" class="img-modulo-home"/>
            </div>
        </div>
        <div class="col-md-3" *ngIf="user.profile_id === 1 || user.profile_id === 3">
            <div class="container-modulo-home text-center" [style]="active1 ? 'cursor: pointer' : ''" (click)="active1 ? irPagina('users', '1') : ''">
                <h3>Usuarios</h3>
                <img [src]="active1 ? '/assets/img/homepage-businesses-1.jpg' : '/assets/img/homepage-businesses-1.jpg'" class="img-modulo-home"/>
            </div>
        </div>
    </div>
</div>

<div class="container-footer">
    <app-footer></app-footer>
</div>

